export default __webpack_public_path__ + "static/media/Lato-BoldItalic.4113fd37.ttf";